import React from 'react';
import { ActivityLogList } from '../../components/activity';

/**
 * Activity Logs page
 * Displays a filterable list of activity logs for the current project
 */
const ActivityLogs: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Activity Logs</h1>
        <p className="text-gray-600">
          View and filter activity logs across the project
        </p>
      </div>

      <div className="grid grid-cols-1 gap-6">
        <ActivityLogList showFilters={true} maxHeight="calc(100vh - 240px)" />
      </div>
    </div>
  );
};

export default ActivityLogs; 

